import { DomainDecommissioning } from '~/constants/ff.posthog';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { useDomainWhitelisted } from './useDomainWhitelisted';

export const useDomainDecommissioningVisible = () => {
  const isEnabled = useFeatureFlag(DomainDecommissioning);
  const { isWhitelisted } = useDomainWhitelisted();
  return isEnabled && isWhitelisted;
};
